import {useQuery} from 'react-query';
import {getWantedPromotedRequirement} from '.';
interface IUseGetWantedPromotedRequirementProps {
  guid?: string;
}
const useGetWantedPromotedRequirement = ({
  guid,
}: IUseGetWantedPromotedRequirementProps) => {
  const {data, isLoading, refetch} = useQuery({
    queryKey: ['WantedPromotedRequirement'],
    queryFn: () => getWantedPromotedRequirement(guid),
    enabled: guid ? true : false,
  });
  return {
    GetWantedPromotedRequirementData: data,
    GetWantedPromotedRequirementIsLoading: isLoading,
    refetch,
  };
};

export default useGetWantedPromotedRequirement;
